module.exports = {
  langs: [
    'es',
    'en',
    'ru',
  ],
  defaultLangKey: 'es',
};
